import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconV2RotateClockwiseOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" data-name="Artwork" viewBox="0 0 32 32" width="1em" height="1em"><path d="M28 4h2v11H19v-2h7.565a457 457 0 0 1-4.279-4.3C20.176 6.547 17.792 5.5 15 5.5 9.014 5.5 4.5 10.014 4.5 16c0 5.963 5.037 11 11 11l-1.348 1.925C7.711 28.225 2.5 22.592 2.5 16 2.5 8.874 7.874 3.5 15 3.5c3.358 0 6.208 1.243 8.714 3.8 1.538 1.57 3.13 3.159 4.286 4.307z" /></svg>
);
